"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-non-null-assertion */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const FastenersUtils_1 = require("~/components/Cad3d/utils/FastenersUtils");
const Button_1 = require("~/components/UI/Button");
const Dropdown_1 = require("~/components/UI/Dropdown");
const Widget_1 = require("~/components/UI/Widget");
const consts_1 = require("~/consts/consts");
const useWindowDimensions_1 = __importDefault(require("~/hooks/useWindowDimensions"));
const useProjectStatus_1 = __importDefault(require("~/hooks/useProjectStatus"));
const actions_1 = require("~/store/actions");
const consts_2 = require("~/store/consts");
const selectors_1 = require("~/store/selectors");
const types_1 = require("~/store/types");
const events_1 = require("~/utils/events");
const utils_1 = require("~/utils/utils");
const FastenerPreviewHelper_3d_1 = __importDefault(require("~/components/Cad3d/classes/FastenerPreviewHelper.3d"));
const utils_2 = require("~/components/Cad3d/utils");
const Viewer_1 = __importDefault(require("~/components/Cad3d/Viewer"));
const PanelInSlotUpdateHelper_1 = __importDefault(require("~/components/Cad3d/classes/PanelInSlots/PanelInSlotUpdateHelper"));
const DeletionConfirmationModal_1 = __importDefault(require("./DeletionConfirmationModal"));
const FastenersGroup_1 = require("./FastenersGroup");
const RecommendedFastenersWidget_scss_1 = __importDefault(require("./RecommendedFastenersWidget.scss"));
function RecommendedFastenersWidget({ toggleWidgets }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const { t } = (0, react_i18next_1.useTranslation)('widgets');
    const { height: windowHeight } = (0, useWindowDimensions_1.default)();
    const widgetHeight = (0, react_redux_1.useSelector)((0, selectors_1.selectWidgetHeight)(consts_2.WIDGETS.RECOMMENDED_FASTENERS_WIDGET));
    const projectId = (0, react_redux_1.useSelector)(selectors_1.selectCurrentProjectId);
    const user = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUser);
    const { isLoading, isSaved, isDeleted, data } = (0, react_redux_1.useSelector)(selectors_1.selectRecommendedFasteners);
    const { isOrderCompleted, isProjectArchived, isProjectViewOnly } = (0, useProjectStatus_1.default)();
    const { dispatchToggleWidget, dispatchUpdateItemProject, dispatchDeleteItemProject, dispatchSocketBOM, dispatchUpdateSelectedRecommendedFastener, dispatchSetBOMLoading, } = (0, redux_1.bindActionCreators)({
        dispatchToggleWidget: actions_1.toggleWidget,
        dispatchUpdateItemProject: actions_1.requestUpdateItemProject,
        dispatchDeleteItemProject: actions_1.requestDeleteItemProject,
        dispatchSocketBOM: actions_1.requestSocketBOM,
        dispatchUpdateSelectedRecommendedFastener: actions_1.updateSelectedRecommendedFastener,
        dispatchSetBOMLoading: actions_1.setBOMLoading,
    }, (0, react_redux_1.useDispatch)());
    const componentItemNumber = ((_a = data === null || data === void 0 ? void 0 : data.mainItem.item) === null || _a === void 0 ? void 0 : _a.itemType.name) === types_1.ITEM_TYPE.COMPONENT
        ? (_b = data === null || data === void 0 ? void 0 : data.mainItem.item) === null || _b === void 0 ? void 0 : _b.item_number
        : (_d = (_c = data === null || data === void 0 ? void 0 : data.connectedItem.item) === null || _c === void 0 ? void 0 : _c.item_number) !== null && _d !== void 0 ? _d : '';
    const extrusionSeriesId = ((_e = data === null || data === void 0 ? void 0 : data.mainItem.item) === null || _e === void 0 ? void 0 : _e.itemType.name) === types_1.ITEM_TYPE.EXTRUSION
        ? data === null || data === void 0 ? void 0 : data.mainItem.item.series[0].id
        : (_g = (_f = data === null || data === void 0 ? void 0 : data.connectedItem.item) === null || _f === void 0 ? void 0 : _f.series[0].id) !== null && _g !== void 0 ? _g : 0;
    const extrusionSeriesName = ((_h = data === null || data === void 0 ? void 0 : data.mainItem.item) === null || _h === void 0 ? void 0 : _h.itemType.name) === types_1.ITEM_TYPE.EXTRUSION
        ? data === null || data === void 0 ? void 0 : data.mainItem.item.series[0].name
        : (_k = (_j = data === null || data === void 0 ? void 0 : data.connectedItem.item) === null || _j === void 0 ? void 0 : _j.series[0].name) !== null && _k !== void 0 ? _k : '';
    const editOptions = [
        {
            value: consts_1.EDIT_CURRENT,
            label: t('recommended.edit-current-connection'),
        },
        {
            value: consts_1.EDIT_ALL,
            label: (data === null || data === void 0 ? void 0 : data.connectionType) === types_1.CONNECTION_TYPE.COMPONENT ||
                (data === null || data === void 0 ? void 0 : data.connectionType) === types_1.CONNECTION_TYPE.PANEL_TO_EXTRUSION_SIDE ||
                (data === null || data === void 0 ? void 0 : data.connectionType) === types_1.CONNECTION_TYPE.PANEL_TO_EXTRUSION_SLOT
                ? `${t('recommended.edit-for-all')} #${componentItemNumber}`
                : t('recommended.edit-all-connections'),
        },
    ];
    const [selectedEditOption, setSelectedEditOption] = (0, react_1.useState)(editOptions[0].value);
    const [lastRenderTime, setLastRenderTime] = (0, react_1.useState)(Date.now());
    FastenerPreviewHelper_3d_1.default.onFastenersPreviewApplied = () => setLastRenderTime(Date.now());
    const [lastUpdateValidationTime, setLastUpdateValidationTime] = (0, react_1.useState)(Date.now());
    FastenerPreviewHelper_3d_1.default.onConnectionValidationUpdated = () => setLastUpdateValidationTime(Date.now());
    const mainConnectionObject = (0, react_1.useMemo)(() => {
        var _a;
        return Viewer_1.default.instance.getObjectById((_a = data === null || data === void 0 ? void 0 : data.connectionUuid) !== null && _a !== void 0 ? _a : '');
    }, [selectedEditOption, isLoading, lastRenderTime]);
    const isFastenerChecked = (fastenerItemNumber) => {
        return !!(mainConnectionObject === null || mainConnectionObject === void 0 ? void 0 : mainConnectionObject.getFasteners().some((fastener) => fastener.partDetails.itemNumber === fastenerItemNumber));
    };
    const isAnyFastenerSelected = (0, react_1.useMemo)(() => {
        return !!(data === null || data === void 0 ? void 0 : data.fasteners.some((fastenerGroup) => fastenerGroup.items.some((fastener) => isFastenerChecked(fastener.item_number))));
    }, [data === null || data === void 0 ? void 0 : data.fasteners, mainConnectionObject === null || mainConnectionObject === void 0 ? void 0 : mainConnectionObject.getFastenerCount(), selectedEditOption, lastRenderTime]);
    const handleClose = () => {
        FastenerPreviewHelper_3d_1.default.cancelApplication();
        const action = {
            widgetName: consts_2.WIDGETS.RECOMMENDED_FASTENERS_WIDGET,
            show: false,
        };
        toggleWidgets(action);
        setSelectedEditOption(consts_1.EDIT_CURRENT);
        dispatchToggleWidget(action);
    };
    const getConnectionsToProcess = (all = false) => {
        var _a, _b;
        if (!data) {
            return [];
        }
        const { similarConnectionIds } = data;
        // get all similar connections (fasteners)
        if (all) {
            return (_a = similarConnectionIds === null || similarConnectionIds === void 0 ? void 0 : similarConnectionIds.all) !== null && _a !== void 0 ? _a : [];
        }
        // get connections for one panel
        return (_b = similarConnectionIds === null || similarConnectionIds === void 0 ? void 0 : similarConnectionIds.current) !== null && _b !== void 0 ? _b : [];
    };
    const deleteFasteners = () => __awaiter(this, void 0, void 0, function* () {
        var _o, _p;
        if (!data || !(data === null || data === void 0 ? void 0 : data.selected) || !projectId) {
            return;
        }
        const { connectionType, connectionUuid, selected } = data;
        FastenerPreviewHelper_3d_1.default.cancelApplication();
        const payload = {
            componentItemNumber,
            connectionType,
            deleteAll: selectedEditOption,
            extrusionSeriesId,
            modifierId: (_o = user === null || user === void 0 ? void 0 : user.id) !== null && _o !== void 0 ? _o : 0,
            projectId,
            projectItemId: (_p = selected[0]) === null || _p === void 0 ? void 0 : _p.id,
            connectionUuid,
        };
        dispatchDeleteItemProject(payload);
        const updatedConnectionObjects = [];
        if (connectionUuid) {
            const connectionObject = (0, FastenersUtils_1.deleteFastenersForConnectionByUUID)(connectionUuid);
            if (connectionObject) {
                updatedConnectionObjects.push(connectionObject);
            }
            document.body.dispatchEvent((0, events_1.deleteFastenersEvent)(payload));
        }
        getConnectionsToProcess(payload.deleteAll === consts_1.EDIT_ALL).forEach((uuid) => {
            if (uuid === connectionUuid) {
                return;
            }
            const connectionObject = (0, FastenersUtils_1.deleteFastenersForConnectionByUUID)(uuid);
            if (connectionObject) {
                updatedConnectionObjects.push(connectionObject);
            }
            document.body.dispatchEvent((0, events_1.deleteFastenersEvent)(Object.assign(Object.assign({}, payload), { connectionUuid: uuid })));
        });
        PanelInSlotUpdateHelper_1.default.onFastenersUpdated(updatedConnectionObjects);
        PanelInSlotUpdateHelper_1.default.syncUpdate();
        dispatchSetBOMLoading();
        handleClose();
    });
    const handleDeleteClick = () => {
        if ((data === null || data === void 0 ? void 0 : data.selected.length) === 0) {
            return;
        }
        if (isAnyFastenerSelected && data) {
            const type = data.connectionType;
            const middleOfTitle = type === types_1.CONNECTION_TYPE.PANEL_TO_EXTRUSION_SLOT ? t('recommended.panel-gaskets') : t('recommended.fasteners');
            let endOfTitle = '';
            if (selectedEditOption === consts_1.EDIT_ALL) {
                if (type === types_1.CONNECTION_TYPE.PANEL_TO_EXTRUSION_SIDE) {
                    endOfTitle = ` ${t('recommended.for-all')} #${componentItemNumber} ${t('recommended.connected-to-side-faces-of')} ${extrusionSeriesName} ${t('recommended.of-extrusions')}`;
                }
                else if (type === types_1.CONNECTION_TYPE.PANEL_TO_EXTRUSION_SLOT) {
                    endOfTitle = ` ${t('recommended.for-all')} #${componentItemNumber} ${t('recommended.connected-to-slots-of')} ${extrusionSeriesName} ${t('recommended.of-extrusions')}`;
                }
                else if (type === types_1.CONNECTION_TYPE.PERPENDICULAR ||
                    type === types_1.CONNECTION_TYPE.END_TO_END ||
                    type === types_1.CONNECTION_TYPE.ANGLED) {
                    endOfTitle = ` ${t('recommended.from-all')} ${type} ${t('recommended.connections-of')} ${extrusionSeriesName}`;
                }
            }
            (0, events_1.showModal)(react_1.default.createElement(DeletionConfirmationModal_1.default, { onSubmit: deleteFasteners, middleOfTitle: middleOfTitle, endOfTitle: endOfTitle }));
        }
    };
    const isCombinedFasteners = () => selectedEditOption === consts_1.EDIT_CURRENT &&
        ((data === null || data === void 0 ? void 0 : data.connectionType) === types_1.CONNECTION_TYPE.END_TO_END ||
            (data === null || data === void 0 ? void 0 : data.connectionType) === types_1.CONNECTION_TYPE.ANGLED ||
            (data === null || data === void 0 ? void 0 : data.connectionType) === types_1.CONNECTION_TYPE.PERPENDICULAR);
    const handleSelect = (fastener) => {
        if (data === null || data === void 0 ? void 0 : data.connectionType) {
            if (isCombinedFasteners()) {
                if (isFastenerChecked(fastener.item_number) && selectedEditOption === consts_1.EDIT_CURRENT) {
                    FastenerPreviewHelper_3d_1.default.removeFastenerInSingleConnectionMode(fastener);
                }
                else {
                    FastenerPreviewHelper_3d_1.default.applyFastener(fastener, PanelInSlotUpdateHelper_1.default.onFastenersUpdated.bind(PanelInSlotUpdateHelper_1.default), true);
                }
            }
            else {
                FastenerPreviewHelper_3d_1.default.applyFastener(fastener, PanelInSlotUpdateHelper_1.default.onFastenersUpdated.bind(PanelInSlotUpdateHelper_1.default));
            }
            dispatchUpdateSelectedRecommendedFastener({
                fastener,
                connectionType: data.connectionType,
                combineFasteners: isCombinedFasteners(),
                selected: !fastener.selected,
            });
        }
    };
    const checkFlipable = (fastenerItemNumber) => {
        var _a;
        return (_a = (selectedEditOption === consts_1.EDIT_CURRENT &&
            mainConnectionObject &&
            utils_2.ConnectionUtils.checkIfFastenersInConnectionCanBeFlipped(mainConnectionObject, fastenerItemNumber))) !== null && _a !== void 0 ? _a : false;
    };
    const flipFastener = (fastenerItemNumber) => FastenerPreviewHelper_3d_1.default.flipFastener(fastenerItemNumber, PanelInSlotUpdateHelper_1.default.onFastenersUpdated.bind(PanelInSlotUpdateHelper_1.default));
    const adjustManually = (fastenerItem) => __awaiter(this, void 0, void 0, function* () {
        FastenerPreviewHelper_3d_1.default.activateManualEditingMode(fastenerItem);
    });
    const isFastenerCompatible = (0, react_1.useMemo)(() => (fastenerItem) => {
        let result;
        if (selectedEditOption === consts_1.EDIT_ALL) {
            result = true;
        }
        else if (mainConnectionObject === null || mainConnectionObject === void 0 ? void 0 : mainConnectionObject.getFasteners().some((fastener) => fastener.partDetails.itemNumber === fastenerItem.item_number)) {
            result = false;
        }
        else {
            result = !FastenerPreviewHelper_3d_1.default.getAppliableFastenersObjectsForCurrentConnection(fastenerItem, true).length;
        }
        return result;
    }, [lastUpdateValidationTime, selectedEditOption, lastRenderTime]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        const tempProcessConnection = getConnectionsToProcess(selectedEditOption === consts_1.EDIT_ALL);
        if (!(data === null || data === void 0 ? void 0 : data.connectionUuid)) {
            return;
        }
        const processConnections = tempProcessConnection.length ? tempProcessConnection : [data.connectionUuid];
        if (processConnections.length === 1 && selectedEditOption === consts_1.EDIT_CURRENT) {
            FastenerPreviewHelper_3d_1.default.setDataForEditSingleConnection(processConnections[0], (_b = (_a = data === null || data === void 0 ? void 0 : data.fasteners) === null || _a === void 0 ? void 0 : _a.flatMap((fastenersGroup) => fastenersGroup.items)) !== null && _b !== void 0 ? _b : []);
        }
        else {
            FastenerPreviewHelper_3d_1.default.setProcessConnections(processConnections, data.connectionUuid);
        }
    }, [selectedEditOption, isLoading]);
    (0, react_1.useEffect)(() => {
        if (isSaved === types_1.LOADING_STATE.COMPLETE && projectId) {
            dispatchSocketBOM({ projectId, userId: user === null || user === void 0 ? void 0 : user.id });
        }
    }, [isSaved]);
    (0, react_1.useEffect)(() => {
        if (isDeleted === types_1.LOADING_STATE.COMPLETE && projectId) {
            dispatchSocketBOM({ projectId, userId: user === null || user === void 0 ? void 0 : user.id });
        }
    }, [isDeleted]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (((_a = data === null || data === void 0 ? void 0 : data.fasteners) === null || _a === void 0 ? void 0 : _a.length) && !isOrderCompleted && !isProjectArchived && !isProjectViewOnly) {
            dispatchToggleWidget({
                widgetName: consts_2.WIDGETS.RECOMMENDED_FASTENERS_WIDGET,
                show: true,
            });
        }
        else {
            dispatchToggleWidget({
                widgetName: consts_2.WIDGETS.RECOMMENDED_FASTENERS_WIDGET,
                show: false,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data === null || data === void 0 ? void 0 : data.fasteners]);
    (0, react_1.useEffect)(() => {
        if (selectedEditOption === consts_1.EDIT_ALL) {
            FastenerPreviewHelper_3d_1.default.deactivateManualEditingMode();
        }
    }, [selectedEditOption]);
    const updateConnectionFastener = (selectedFastener, basePayload, connectionData, serverSync = false) => __awaiter(this, void 0, void 0, function* () {
        const { connectionObject: currentConnectedObject } = connectionData;
        const connectionObj = currentConnectedObject.getConnection();
        const connectionUuid = (connectionObj.connectionUuid || connectionObj.uuid);
        const payload = Object.assign({}, basePayload);
        const fastenerItemNumber = selectedFastener.item_number;
        const connection = currentConnectedObject.getConnection();
        const { numberOfFasteners: quantity = 0, connectionType } = connection;
        // TODO: Implement checking of panel gaskets after the visualization of this group is added
        if (quantity === 0 && connectionType !== types_1.CONNECTION_TYPE.PANEL_TO_EXTRUSION_SLOT) {
            return false;
        }
        payload.createItems.push({
            connectionUuids: [connectionUuid],
            connections: [connection],
            itemNumber: fastenerItemNumber,
            projectId,
            quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
            size: 0,
            uuid: (0, utils_1.uuidv4)(),
        });
        payload.createItems[0].quantity = quantity;
        if (serverSync) {
            dispatchUpdateItemProject(payload);
        }
        document.body.dispatchEvent((0, events_1.updateFastenersEvent)(payload));
        return true;
    });
    const getSelectedFastener = () => {
        if (!data) {
            return null;
        }
        for (let i = 0; i < data.fasteners.length; i += 1) {
            const { items } = data.fasteners[i];
            for (let j = 0; j < items.length; j += 1) {
                if (items[j].selected) {
                    return items[j];
                }
            }
        }
        return null;
    };
    const handleSave = () => __awaiter(this, void 0, void 0, function* () {
        var _q;
        if (!data || !(data === null || data === void 0 ? void 0 : data.selected) || !projectId) {
            return;
        }
        const { connectedItem, connectionUuid, selected, mainItem } = data;
        const payload = {
            connectedItem,
            createItems: [],
            deleteItems: selected.map((item) => Number(item.id)),
            mainItem,
            updateAll: selectedEditOption === consts_1.EDIT_ALL,
            modifierId: (_q = user === null || user === void 0 ? void 0 : user.id) !== null && _q !== void 0 ? _q : 0,
        };
        const selectedFastener = getSelectedFastener();
        if (!selectedFastener) {
            return;
        }
        const baseExtrusionWidth = (0, FastenersUtils_1.getConnectedExtrusionWidthByConnectionUUID)(connectionUuid);
        const finalizeApplicationResult = FastenerPreviewHelper_3d_1.default.finalizeApplication();
        PanelInSlotUpdateHelper_1.default.syncUpdate();
        const mainConnectionResult = finalizeApplicationResult.find((connectionData) => {
            const uuid = (connectionData.connectionObject.getConnection().connectionUuid ||
                connectionData.connectionObject.getConnection().uuid);
            return uuid === connectionUuid;
        });
        if (!mainConnectionResult || !mainConnectionResult.previewData) {
            FastenerPreviewHelper_3d_1.default.cancelApplication();
            handleClose();
            return;
        }
        finalizeApplicationResult.forEach((connectionData) => __awaiter(this, void 0, void 0, function* () {
            const uuid = (connectionData.connectionObject.getConnection().connectionUuid ||
                connectionData.connectionObject.getConnection().uuid);
            if (uuid === connectionUuid) {
                return;
            }
            if (selectedFastener.recommendedScrewFasteners) {
                const extrusionWidth = (0, FastenersUtils_1.getConnectedExtrusionWidthByConnectionUUID)(uuid);
                if (extrusionWidth !== baseExtrusionWidth) {
                    return;
                }
            }
            const isUpdated = yield updateConnectionFastener(selectedFastener, payload, connectionData);
            if (isUpdated) {
                dispatchSetBOMLoading();
                handleClose();
            }
        }));
        updateConnectionFastener(selectedFastener, payload, mainConnectionResult, true);
        dispatchSetBOMLoading();
        handleClose();
    });
    const handleChangeSelectedEditOption = (value) => {
        setSelectedEditOption(value);
    };
    const getTitle = () => {
        var _a;
        if (isCombinedFasteners()) {
            return t('recommended.edit-combined-fasteners');
        }
        if (((_a = data === null || data === void 0 ? void 0 : data.fasteners[0]) === null || _a === void 0 ? void 0 : _a.name) === consts_2.INCLUDED) {
            t('recommended.included-fasteners');
        }
        if ((data === null || data === void 0 ? void 0 : data.connectionType) === types_1.CONNECTION_TYPE.PANEL_TO_EXTRUSION_SLOT) {
            t('recommended.recommended-panel-gaskets');
        }
        return t('recommended.recommended-fasteners');
    };
    const getMainContent = () => {
        if (!(isLoading === types_1.LOADING_STATE.COMPLETE && data)) {
            return 'loading...';
        }
        if (data.fasteners && data.fasteners.length > 0) {
            const getSelectorType = () => {
                var _a;
                if (((_a = data === null || data === void 0 ? void 0 : data.fasteners[0]) === null || _a === void 0 ? void 0 : _a.name) === consts_2.INCLUDED) {
                    return 'none';
                }
                return isCombinedFasteners() ? 'checkbox' : 'radio';
            };
            return data.fasteners.map((category) => (react_1.default.createElement(FastenersGroup_1.FastenersGroup, { key: category.name, showTitle: (data === null || data === void 0 ? void 0 : data.connectionType) !== types_1.CONNECTION_TYPE.PANEL_TO_EXTRUSION_SLOT, category: category, selectorType: getSelectorType(), onSelect: handleSelect, checkIsFlipable: checkFlipable, onFlipFastener: flipFastener, isFastenerChecked: isFastenerChecked, onAdjustManually: adjustManually, isDisabled: isFastenerCompatible })));
        }
        return 'No  fasteners applies';
    };
    return (react_1.default.createElement(Widget_1.Widget, { widgetName: consts_2.WIDGETS.RECOMMENDED_FASTENERS_WIDGET, defaultPosition: {
            x: 352,
            y: windowHeight - widgetHeight - 104,
        } },
        react_1.default.createElement("div", { className: RecommendedFastenersWidget_scss_1.default.widget, "data-testid": "recommended-fasteners-widget" },
            react_1.default.createElement("header", null,
                ((_l = data === null || data === void 0 ? void 0 : data.fasteners[0]) === null || _l === void 0 ? void 0 : _l.name) !== consts_2.INCLUDED && (react_1.default.createElement("div", { className: RecommendedFastenersWidget_scss_1.default.actions },
                    react_1.default.createElement(Dropdown_1.Dropdown, { onChange: handleChangeSelectedEditOption, options: editOptions, defaultLabel: editOptions[0].label, selectedValue: selectedEditOption }),
                    data && data.connectionType !== types_1.CONNECTION_TYPE.COMPONENT && (react_1.default.createElement("button", { type: "button", className: `${RecommendedFastenersWidget_scss_1.default.delete} ${RecommendedFastenersWidget_scss_1.default.title} ${isAnyFastenerSelected && (data === null || data === void 0 ? void 0 : data.selected.length) > 0 ? '' : RecommendedFastenersWidget_scss_1.default.disabled}`, onClick: handleDeleteClick, onKeyDown: (e) => e.preventDefault(), tabIndex: 0, "data-testid": "delete-fasteners-btn" }, `${t('recommended.delete')} ${data.connectionType === types_1.CONNECTION_TYPE.PANEL_TO_EXTRUSION_SLOT
                        ? t('recommended.panel-gaskets')
                        : t('recommended.fasteners')}`)))),
                react_1.default.createElement("div", { className: RecommendedFastenersWidget_scss_1.default.title }, getTitle())),
            react_1.default.createElement("main", null, getMainContent()),
            react_1.default.createElement("footer", null,
                react_1.default.createElement(Button_1.Button, { onClick: handleClose, "data-testid": "close-widget-btn" }, "Close"),
                ((_m = data === null || data === void 0 ? void 0 : data.fasteners[0]) === null || _m === void 0 ? void 0 : _m.name) !== consts_2.INCLUDED && (react_1.default.createElement(Button_1.Button, { onClick: handleSave, disabled: !isAnyFastenerSelected, variant: "primary", "data-testid": "save-fasteners-btn" }, "Save"))))));
}
exports.default = RecommendedFastenersWidget;
